import React, { useState, useEffect } from 'react';
import {
  makeStyles,
  Divider,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
  Checkbox,
  FormGroup,
  FormControlLabel
} from "@material-ui/core";
import { useSelector, useDispatch } from 'react-redux';
import styles from './Consent.module.css';
import { selectOpen, getUploadFileInfo } from "./consentSlice";
import { selectLanguage } from "../language/languageSlice";
import { selectEmail } from "../email/emailSlice";
import { set } from "./consentSlice";
import config from "../../config";

const useStyles = makeStyles((theme) => ({

  root: {
    //maxWidth:"60vw",
    width: "100%",
    height: "100vh",
    margin: "auto"
  },
  divContainer: {
    margin: "1vh 0vw"
  }
}));

function DisplayQuestions(email) {
  const dispatch = useDispatch();
  const [purposes, setPurposes] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});

  const getPurposes = async () => {
    try {
      console.log('email:', email);
      const bodyReq = { identifier: email };
      const response = await fetch(config.GetActivePurposes_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bodyReq)
      });
      const data = await response.json();
      setPurposes(data.result.purposes);
      const newCheckedItems = data.result.purposes.reduce((acc, purpose) => {
        acc[purpose.id] = purpose.status === "approved";
        return acc;
      }, {});
      setCheckedItems(newCheckedItems);
      dispatch(set(Object.entries(newCheckedItems).map(([id, status]) => ({ id, status }))));
      console.log('consentList default: ', Object.entries(newCheckedItems).map(([id, status]) => ({ id, status })));
    } catch (error) {
      console.error("Error fetching purpose:", error);
    }
  };

  useEffect(() => {
    getPurposes();
  }, []);

  const handleChange = (event) => {
    const { name, checked } = event.target;
    setCheckedItems((prevState) => {
      const updatedCheckedItems = {
        ...prevState,
        [name]: checked,
      };
  
      dispatch(set(Object.entries(updatedCheckedItems).map(([id, status]) => ({ id, status }))));
      console.log('consentList changed: ', Object.entries(updatedCheckedItems).map(([id, status]) => ({ id, status })));
  
      return updatedCheckedItems;
    });
  };

  return purposes.length > 0 ? (
    <div>
      <h2 className="MuiTypography-root MuiTypography-h6" style={{ color: "#000000DE" }}>
        แบบสอบถามความยินยอม
      </h2>
      <FormGroup id="questionForm">
        {purposes.map((purpose) => (
          <FormControlLabel
            key={purpose.id}
            control={
              <Checkbox
                checked={checkedItems[purpose.id] || false}
                onChange={handleChange}
                name={purpose.id}
              />
            }
            label={purpose.name} htmlFor={purpose.id}
          />
        ))}
      </FormGroup>
    </div>
  )
    : <></>;
}

export function Consent() {
  //const language = useSelector(selectLanguage);
  const classes = useStyles();
  //const source = "https://econsentweb.azurewebsites.net/ConsentIframe/Index?appcode=PDPA&language=" + language;
  //return (<React.Fragment><Divider fullWidth className={classes.divContainer} /><div > <iframe src={source} frameBorder="0" scrolling="no" className={classes.root} onChange={(e) => console.log(e.target.value)} title="Consent" id="iframeConsent" /></div></React.Fragment>);

  const email = useSelector(selectEmail);
  return email ? (<React.Fragment><Divider fullWidth className={classes.divContainer} />{DisplayQuestions(email)}</React.Fragment>) : <></>;
}